module.exports = "/images/Belgium.png?9f776340d24bf0c6f0b9f9b17d61058b";